import React, { Component } from 'react'
import _ from 'lodash'

import { CONFIG, lower } from 'velox-visualizer-tools'

export class EditPencil extends Component{
	render(){
		return (
		<svg x="0px" y="0px" viewBox="0 0 469.331 469.331" className={'icon-edit-pencil ' + (this.props.className || '')}>
			<g>
				<path d="M438.931,30.403c-40.4-40.5-106.1-40.5-146.5,0l-268.6,268.5c-2.1,2.1-3.4,4.8-3.8,7.7l-19.9,147.4   c-0.6,4.2,0.9,8.4,3.8,11.3c2.5,2.5,6,4,9.5,4c0.6,0,1.2,0,1.8-0.1l88.8-12c7.4-1,12.6-7.8,11.6-15.2c-1-7.4-7.8-12.6-15.2-11.6   l-71.2,9.6l13.9-102.8l108.2,108.2c2.5,2.5,6,4,9.5,4s7-1.4,9.5-4l268.6-268.5c19.6-19.6,30.4-45.6,30.4-73.3   S458.531,49.903,438.931,30.403z M297.631,63.403l45.1,45.1l-245.1,245.1l-45.1-45.1L297.631,63.403z M160.931,416.803l-44.1-44.1   l245.1-245.1l44.1,44.1L160.931,416.803z M424.831,152.403l-107.9-107.9c13.7-11.3,30.8-17.5,48.8-17.5c20.5,0,39.7,8,54.2,22.4   s22.4,33.7,22.4,54.2C442.331,121.703,436.131,138.703,424.831,152.403z"/>
			</g>
		</svg>
		)
	}
}

export class SnowFlake extends Component{
	render(){
		return (
			<svg viewBox="0 0 92.64 87.21">
				<path fill={this.props.color || '#0080c6'} d="M0,40.8H12L4.85,28.4H11l7.18,12.36h8.18L19.21,28.31H34.3l-4.48-7.77H15.49l-3.06-5.3H26.77l-6-10.43,4.61-2.67L31.5,12.77,37.45,2.53h6.12l-9,15.58,4.16,7.22,7.85-13.26,7.53,12.76,4.06-7L51,5.31,54.1,0l7.16,12.44L67.25,2l4.61,2.67L65.77,15.3H77.58l3.08,5.35h-18l-4.43,7.68H73.9L66.63,40.76h7.93l7.19-12.38h6.12L80.71,40.77H92.64v5.4H80.43l5.9,10.31-3.06,5.31-9-15.57h-7.8L74.06,59H58.17l4.31,7.48h18l-3.1,5.38H65.59L71.7,82.5l-4.61,2.67-6-10.39L53.93,87.21l-3.06-5.3L58,69.43l-4-7L46.43,75.56,38.72,62.22l-4,6.89,9,15.56H37.62L31.67,74.44,25.54,85.07,20.93,82.4,26.9,72H12.58l3.07-5.33H30L34.39,59H19.33l7.26-12.81H18.38L9.43,61.78l-3.06-5.3,5.86-10.25H0ZM51,30.28l-4.4-7.46-4.71,8,4.42,7.65L51,30.28M46.43,64.63,50.84,57l-4.56-7.9-4.41,7.65,4.56,7.89M55,53.49h9.48l-4.29-7.27H50.78L55,53.49m.09-19.64-4,6.93h9.21l4.06-6.93ZM32.88,46.22l-4.11,7.26h8.84l4.18-7.26Zm4.6-12.4H28.65l4,6.93h8.86l-4-6.93" />
			</svg>
		)
	}
}

export class Filter extends Component{
	render(){
		let props = _.assign({}, this.props)
		delete props.className
		return (
			<svg  x="0px" y="0px" viewBox="0 0 611.999 611.999" className={'icon-filter ' + (this.props.className || '')} {...props}>
				<path d="M594.128,38.988H17.872C8.002,38.988,0,46.99,0,56.86v116.011c0,9.87,8.002,17.872,17.872,17.872h43.345l177.206,226.032
				v138.364c0,6.286,3.302,12.107,8.692,15.336c2.822,1.69,5.997,2.536,9.18,2.536c2.897,0,5.801-0.704,8.439-2.118l99.41-53.249
				c5.808-3.113,9.433-9.165,9.433-15.754v-85.115l177.206-226.034h43.344c9.87,0,17.872-8.002,17.872-17.872V56.86
				C612,46.99,603.998,38.988,594.128,38.988z M341.641,399.573c-2.466,3.147-3.808,7.031-3.808,11.027v80.586l-63.666,34.103
				v-114.69c0-3.997-1.34-7.88-3.808-11.027l-163.723-208.83h398.73L341.641,399.573z M576.256,154.997H35.744V74.731h540.512
				V154.997z"/>
			</svg>
		)
	}
}

export class Sort extends Component{
	render(){
		let props = _.assign({}, this.props)
		delete props.className
		return (
			<svg x="0px" y="0px" viewBox="0 0 427.484 427.484" className={'icon-sort ' + (this.props.className || '')} {...props}>
				<path d="M405.943,290.254L302.096,425.338c-1.04,1.354-2.66,2.146-4.374,2.146c-1.702,0-3.321-0.798-4.368-2.146L189.511,290.254
					c-0.769-0.993-1.144-2.176-1.144-3.357c0-1.152,0.364-2.329,1.108-3.322c1.499-1.975,4.125-2.707,6.434-1.809l68.76,27.166V21.01
					c0-3.047,2.477-5.503,5.515-5.503h55.106c3.038,0,5.509,2.456,5.509,5.503v287.922l68.76-27.166
					c2.305-0.898,4.93-0.166,6.419,1.809C407.473,285.561,407.461,288.28,405.943,290.254z M238.012,143.913
					c0.744-0.993,1.105-2.167,1.105-3.322c0-1.176-0.379-2.367-1.142-3.36L134.125,2.148C133.081,0.792,131.458,0,129.759,0
					c-1.714,0-3.328,0.798-4.377,2.148L21.539,137.23c-1.519,1.969-1.525,4.69-0.03,6.683c1.487,1.968,4.114,2.707,6.419,1.803
					l68.766-27.163v287.919c0,3.05,2.462,5.509,5.506,5.509h55.109c3.041,0,5.515-2.459,5.515-5.509V118.552l68.763,27.163
					C233.886,146.62,236.51,145.88,238.012,143.913z"/>
			</svg>
		)
	}
}
export class ColorWheel extends Component{
	render(){
		return <img src={ CONFIG.UI_IMG_BUCKET + '/color_wheel.png'} alt="color wheel" className="icon color-wheel" />
	}
}

export class ShoppingCart extends Component{
	render(){
		return <span className="icon-shopping-cart fa fa-cart-plus" aria-hidden="true"></span>
	}
}

export class CircleCheckmark extends Component{
	render(){
		return <span className="fa fa-check-circle" aria-hidden="true"></span>
	}
}

export class Remove extends Component{
	render(){
		return <span className="icon-remove fa fa-times" aria-hidden="true" onClick={this.props.onClick}></span>
	}
}

export class Caret extends Component{
	render(){
		let direction = lower(this.props.direction) || 'left',
			color = this.props.color,
			style = color ? { fill: color } : {}

		switch(direction){
			case 'left':
				return (
					<svg className="caret caret-left" viewBox="0 0 29.07 49.66"><polygon points="24.83 48.24 27.66 45.41 7.07 24.83 27.66 4.24 24.83 1.41 1.42 24.83 24.83 48.24" className="caret-fill" style={ style } /><path d="M24.83,49.66l4.24-4.24L8.49,24.83,29.07,4.24,24.83,0,0,24.83Zm1.41-4.24-1.41,1.41-22-22,22-22,1.41,1.41L5.66,24.83Z" className="caret-stroke" style={ style } /></svg>
				)
			case 'right':
				return (
					<svg className="caret caret-right" viewBox="0 0 29.07 49.66"><polygon points="4.24 48.24 1.41 45.41 22 24.83 1.41 4.24 4.24 1.41 27.66 24.83 4.24 48.24" className="caret-fill" style={ style } /><path d="M4.24,49.66,0,45.41,20.58,24.83,0,4.24,4.24,0,29.07,24.83ZM2.83,45.41l1.41,1.41,22-22-22-22L2.83,4.24,23.41,24.83Z" className="caret-stroke" style={style} /></svg>
				)
			case 'down':
				return (
					<svg className="caret caret-down" viewBox="0 0 49.66 29.07"><polygon className="caret-fill" style={style} points="24.83 27.66 1.41 4.24 4.24 1.41 24.83 22 45.41 1.41 48.24 4.24 24.83 27.66"/><path className="caret-stroke" style={style} d="M24.83,29.07,0,4.24,4.24,0,24.83,20.58,45.41,0l4.25,4.24Zm0-5.66L4.24,2.83,2.82,4.24l22,22,22-22L45.41,2.83Z"/></svg>
				)
			case 'up':
				return (
					<svg className="caret caret-up" viewBox="0 0 49.66 29.07"><path className="caret-stroke" style={style} d="M24.83,0,49.66,24.83l-4.24,4.24L24.83,8.49,4.25,29.07,0,24.83Zm0,5.66L45.42,26.24l1.42-1.41-22-22-22,22,1.41,1.41Z"/></svg>
				)
			default:
				return (
					<svg className="caret caret-right" viewBox="0 0 29.07 49.66"><polygon points="4.24 48.24 1.41 45.41 22 24.83 1.41 4.24 4.24 1.41 27.66 24.83 4.24 48.24" className="caret-fill" style={ style } /><path d="M4.24,49.66,0,45.41,20.58,24.83,0,4.24,4.24,0,29.07,24.83ZM2.83,45.41l1.41,1.41,22-22-22-22L2.83,4.24,23.41,24.83Z" className="caret-stroke" style={style} /></svg>
				)
		}
	}
}

export class Cancel extends Component{
	render(){
		let { color } = this.props
		let style = color ? { fill: color } : {}
		return (
			<svg className="icon-cancel" x="0px" y="0px" viewBox="0 0 94.9 94.9"  onClick={this.props.onClick}>
				<g>
					<path className="icon-cancel-svg" style={style} d="M55.9,47.5L94.3,9.1c0.8-0.8,0.8-2.2,0-3l-5.5-5.5C88.4,0.2,87.9,0,87.3,0c-0.6,0-1.1,0.2-1.5,0.6L47.5,39
						L9.1,0.6c-0.8-0.8-2.2-0.8-3,0L0.6,6.1c-0.8,0.8-0.8,2.2,0,3L39,47.5L0.6,85.8c-0.8,0.8-0.8,2.2,0,3l5.5,5.5
						c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6l38.4-38.4l38.4,38.4c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6l5.5-5.5
						c0.8-0.8,0.8-2.2,0-3L55.9,47.5z"/>
				</g>
			</svg>
		)
	}
}

export class ShippingCar extends Component{
	render(){
		return (
			<svg version="1.1" x="0px" y="0px" viewBox="0 0 612 612" className="icon icon-shipping" {...this.props}>
				<g>
					<g>
						<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
							C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
							c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
							 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
							c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
							h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
							c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
							 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
							c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
							c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
							c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
							l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
							c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
							C565.257,281.569,563.532,285.839,560.084,285.839z"/>
					</g>
				</g>
			</svg>
		)
	}
}

export class Warehouse extends Component{
	render(){
		let { color } = this.props
		let style = color ? { fill: color } : {}
		return (
			<svg class="icon icon-warehouse" viewBox="0 0 512 512" width="200px" height="200px" {...this.props}>
				<path d="M507.785,146.242L260.318,1.175c-2.603-1.519-5.803-1.57-8.439-0.111L4.412,137.598C1.69,139.091,0,141.958,0,145.064    v358.4c0,4.719,3.823,8.533,8.533,8.533H51.2c4.71,0,8.533-3.814,8.533-8.533V204.798h392.533v298.667    c0,4.719,3.814,8.533,8.533,8.533h42.667c4.719,0,8.533-3.814,8.533-8.533V153.598C512,150.568,510.396,147.769,507.785,146.242z     M494.933,494.931h-25.6V196.264c0-4.71-3.814-8.533-8.533-8.533H51.2c-4.71,0-8.533,3.823-8.533,8.533v298.667h-25.6V150.099    L255.872,18.344l239.061,140.143V494.931z" style={style}/>
				<path d="M426.667,392.531h-102.4c-4.719,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.814,8.533,8.533,8.533h102.4    c4.719,0,8.533-3.814,8.533-8.533v-102.4C435.2,396.345,431.386,392.531,426.667,392.531z M418.133,494.931H332.8v-85.333h85.333    V494.931z" style={style}/>
				<path d="M384,401.064v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.814,8.533,8.533,8.533h34.133c4.719,0,8.533-3.814,8.533-8.533    v-34.133H384z" style={style}/>
				<path d="M324.267,392.531h-102.4c-4.71,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.823,8.533,8.533,8.533h102.4    c4.719,0,8.533-3.814,8.533-8.533v-102.4C332.8,396.345,328.986,392.531,324.267,392.531z M315.733,494.931H230.4v-85.333h85.333    V494.931z" style={style}/>
				<path d="M281.6,401.064v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.823,8.533,8.533,8.533h34.133    c4.719,0,8.533-3.814,8.533-8.533v-34.133H281.6z" style={style}/>
				<path d="M426.667,290.131h-102.4c-4.719,0-8.533,3.814-8.533,8.533v102.4c0,4.719,3.814,8.533,8.533,8.533h102.4    c4.719,0,8.533-3.814,8.533-8.533v-102.4C435.2,293.945,431.386,290.131,426.667,290.131z M418.133,392.531H332.8v-85.333h85.333    V392.531z" style={style}/>
				<path d="M384,298.664v25.6h-17.067v-25.6h-17.067v34.133c0,4.719,3.814,8.533,8.533,8.533h34.133c4.719,0,8.533-3.814,8.533-8.533    v-34.133H384z" style={style}/>
				<rect x="51.2" y="255.998" width="409.6" height="17.067" style={style}/>
				<rect x="51.2" y="221.864" width="409.6" height="17.067" style={style}/>
				<path d="M298.667,119.464h-85.333c-4.71,0-8.533,3.823-8.533,8.533v34.133c0,4.71,3.823,8.533,8.533,8.533h85.333    c4.719,0,8.533-3.823,8.533-8.533v-34.133C307.2,123.287,303.386,119.464,298.667,119.464z M290.133,153.598h-68.267v-17.067    h68.267V153.598z" style={style}/>
		</svg>
		)
	}
}

export class HardwareParts extends Component{
	render(){
		return (
			<svg viewBox="0 0 35.33 28.36" className="icon icon-hardware-parts">
			    <g>
			        <g>
			            <path className="big-screw"  fillRule="evenodd" d="M29.62,12.57,23.09,9.76V9h6Zm-.49,4.13-6-2.89V12l6,2.81Zm0,3.72-6-2.89V16l6,2.89Zm0,3.56-6-2.89V19.76l6,2.89Zm-3,2.4-3.06-.58V23.31l5.54,2.56ZM34.34,0H18a1,1,0,0,0-1,1V8a1,1,0,0,0,1,1H21V26.62a1.06,1.06,0,0,0,.83,1l4.05.75h.41l4.05-.75a1,1,0,0,0,.83-1V9h3.14a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1Z" />
			            <path className="small-wrench" fillRule="evenodd" d="M8,9.76a3.7,3.7,0,0,0-3.72,3.72A3.78,3.78,0,0,0,8,17.28a3.78,3.78,0,0,0,3.72-3.8A3.7,3.7,0,0,0,8,9.76ZM12.26,7a1,1,0,0,0-.83-.58H4.49A1.25,1.25,0,0,0,3.58,7L.19,13a.74.74,0,0,0,0,1l3.39,6a1.14,1.14,0,0,0,.91.5h6.94a.91.91,0,0,0,.83-.5l3.47-6a.75.75,0,0,0,0-1Z" />
			        </g>
			    </g>
			</svg>

		)
	}
}

export class CheckmarkCircle extends Component{
	render(){
		let fill = this.props.color || '#91DC5A'
		return (
			<svg className='checkmark-circle' x="0px" y="0px" width="512px" height="512px" viewBox="0 0 587.91 587.91">
				<g>
					<path d="M86.451,501.46c26.937,26.936,58.315,48.088,93.265,62.871c36.207,15.314,74.642,23.078,114.239,23.078     c39.596,0,78.032-7.764,114.239-23.078c34.949-14.783,66.328-35.936,93.266-62.871c26.936-26.938,48.09-58.316,62.871-93.266     c15.314-36.207,23.08-74.643,23.08-114.238c0-39.598-7.766-78.033-23.08-114.239c-14.781-34.95-35.936-66.328-62.871-93.265     c-26.938-26.937-58.316-48.09-93.266-62.872C371.986,8.265,333.551,0.501,293.955,0.501c-39.597,0-78.032,7.765-114.239,23.079     c-34.95,14.782-66.328,35.936-93.265,62.872s-48.09,58.315-62.873,93.264C8.265,215.923,0.5,254.358,0.5,293.956     c0,39.596,7.765,78.031,23.079,114.238C38.361,443.144,59.515,474.522,86.451,501.46z M293.955,43.341     c138.411,0,250.614,112.204,250.614,250.615c0,138.41-112.203,250.613-250.614,250.613S43.34,432.366,43.34,293.956     C43.34,155.545,155.544,43.341,293.955,43.341z" fill={fill}/>
					<path d="M293.955,587.909c-39.667,0-78.167-7.778-114.434-23.117c-35.01-14.809-66.442-35.998-93.423-62.979     c-26.983-26.984-48.172-58.417-62.979-93.425C7.778,372.119,0,333.618,0,293.956c0-39.663,7.778-78.165,23.118-114.435     c14.807-35.008,35.997-66.44,62.979-93.423c26.982-26.983,58.415-48.172,93.423-62.979c36.27-15.34,74.771-23.118,114.434-23.118     c39.666,0,78.167,7.778,114.433,23.119c35.009,14.807,66.441,35.997,93.425,62.979c26.984,26.985,48.173,58.417,62.979,93.423     c15.341,36.27,23.119,74.771,23.119,114.434c0,39.662-7.778,78.163-23.119,114.433c-14.806,35.007-35.994,66.439-62.979,93.425     c-26.982,26.98-58.415,48.169-93.425,62.979C372.121,580.131,333.62,587.909,293.955,587.909z M293.955,1.001     c-39.529,0-77.898,7.751-114.044,23.039c-34.889,14.757-66.215,35.874-93.106,62.765c-26.892,26.892-48.009,58.217-62.766,93.105     C8.751,216.057,1,254.427,1,293.956C1,333.483,8.751,371.854,24.039,408c14.757,34.889,35.874,66.214,62.766,93.106     c26.89,26.889,58.215,48.006,93.106,62.765c36.142,15.287,74.512,23.038,114.044,23.038s77.901-7.751,114.044-23.039     c34.89-14.758,66.216-35.875,93.106-62.764c26.893-26.895,48.009-58.22,62.764-93.106     c15.289-36.146,23.041-74.516,23.041-114.044c0-39.529-7.752-77.899-23.041-114.044c-14.754-34.887-35.871-66.212-62.764-93.106     c-26.892-26.891-58.218-48.008-93.106-62.765C371.855,8.752,333.485,1.001,293.955,1.001z M293.955,545.069     c-67.075,0-130.136-26.12-177.565-73.549c-47.429-47.43-73.55-110.489-73.55-177.564S68.96,163.82,116.39,116.391     c47.429-47.429,110.49-73.55,177.565-73.55c67.075,0,130.135,26.121,177.564,73.55c47.43,47.43,73.55,110.49,73.55,177.565     s-26.12,130.135-73.55,177.564C424.09,518.949,361.029,545.069,293.955,545.069z M293.955,43.841     c-66.808,0-129.617,26.017-176.858,73.257c-47.24,47.241-73.257,110.05-73.257,176.858c0,66.808,26.017,129.617,73.257,176.856     c47.24,47.24,110.05,73.257,176.858,73.257s129.617-26.017,176.857-73.257c47.24-47.239,73.257-110.049,73.257-176.856     c0-66.808-26.017-129.618-73.257-176.858C423.571,69.857,360.763,43.841,293.955,43.841z" fill={fill}/>
				</g>
				<g>
					<path d="M228.992,400.794c4.017,4.018,9.465,6.273,15.146,6.273c5.682,0,11.129-2.256,15.146-6.273L442.67,217.409     c8.365-8.365,8.365-21.927,0-30.292s-21.928-8.366-30.293,0l-168.239,168.24l-68.606-68.607c-8.365-8.366-21.927-8.366-30.292,0     c-8.365,8.365-8.365,21.927,0,30.292L228.992,400.794z" fill={fill}/>
					<path d="M244.138,407.567c-5.855,0-11.36-2.28-15.5-6.42l-83.752-83.752c-8.546-8.547-8.546-22.453,0-31     c4.14-4.141,9.645-6.421,15.5-6.421s11.359,2.28,15.5,6.421l68.253,68.253l167.885-167.886c4.14-4.141,9.645-6.42,15.5-6.42     c5.854,0,11.359,2.28,15.5,6.42c4.141,4.14,6.421,9.645,6.421,15.5s-2.28,11.359-6.421,15.5L259.638,401.147     C255.499,405.287,249.994,407.567,244.138,407.567z M160.386,280.975c-5.588,0-10.841,2.176-14.792,6.128     c-8.156,8.157-8.156,21.428,0,29.585l83.752,83.752c3.951,3.951,9.204,6.127,14.792,6.127c5.589,0,10.842-2.176,14.793-6.127     l183.385-183.385c3.951-3.951,6.128-9.205,6.128-14.792s-2.177-10.842-6.128-14.793c-3.951-3.952-9.205-6.127-14.793-6.127     s-10.842,2.176-14.793,6.127L244.138,356.063l-68.96-68.96C171.227,283.151,165.974,280.975,160.386,280.975z" fill={fill}/>
				</g>
			</svg>
		)
	}
}

export class WarningTriangle extends Component{
	render(){
		let color = this.props.color || "#AAAAAA"
		let style = color ? { fill: color } : {}
		return (
			<svg className="icon icon-warning-triangle" x="0px" y="0px" width="554.2px" height="554.199px" viewBox="0 0 554.2 554.199">
				<path fill={color} d="M538.5,386.199L356.5,70.8c-16.4-28.4-46.7-45.9-79.501-45.9c-32.8,0-63.1,17.5-79.5,45.9L12.3,391.6
					c-16.4,28.4-16.4,63.4,0,91.8C28.7,511.8,59,529.3,91.8,529.3H462.2c0.101,0,0.2,0,0.2,0c50.7,0,91.8-41.101,91.8-91.8
					C554.2,418.5,548.4,400.8,538.5,386.199z M316.3,416.899c0,21.7-16.7,38.3-39.2,38.3s-39.2-16.6-39.2-38.3V416
					c0-21.601,16.7-38.301,39.2-38.301S316.3,394.3,316.3,416V416.899z M317.2,158.7L297.8,328.1c-1.3,12.2-9.4,19.8-20.7,19.8
					s-19.4-7.7-20.7-19.8L237,158.6c-1.3-13.1,5.801-23,18-23H299.1C311.3,135.7,318.5,145.6,317.2,158.7z"/>
			</svg>
		)
	}
}


export class QuestionCircle extends Component{
	render(){
		let color = this.props.color || "#AAAAAA"
		return (
			<svg className="icon icon-question-circle" viewBox="0 0 512 512">
				<g>
					<circle fill={color} cx="256" cy="378.5" r="25"/>
					<path fill={color} d="M256,0C114.516,0,0,114.497,0,256c0,141.484,114.497,256,256,256c141.484,0,256-114.497,256-256
						C512,114.516,397.503,0,256,0z M256,472c-119.377,0-216-96.607-216-216c0-119.377,96.607-216,216-216
						c119.377,0,216,96.607,216,216C472,375.377,375.393,472,256,472z"/>
					<path fill={color} d="M256,128.5c-44.112,0-80,35.888-80,80c0,11.046,8.954,20,20,20s20-8.954,20-20c0-22.056,17.944-40,40-40
						c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40c-11.046,0-20,8.954-20,20v50c0,11.046,8.954,20,20,20
						c11.046,0,20-8.954,20-20v-32.531c34.466-8.903,60-40.26,60-77.469C336,164.388,300.112,128.5,256,128.5z"/>
				</g>
			</svg>
		)
	}
}

export class FullScreenIcon extends Component{
	render(){
		let color = this.props.color || "#AAAAAA"
		let style = this.props.style
		return (
			<svg className="icon-full-screen icon" viewBox="0 0 32 32" style={style}>
				<polygon points="27.414,24.586 22.828,20 20,22.828 24.586,27.414 20,32 32,32 32,20 			"/>
				<polygon points="12,0 0,0 0,12 4.586,7.414 9.129,11.953 11.957,9.125 7.414,4.586 			"/>
				<polygon points="12,22.828 9.172,20 4.586,24.586 0,20 0,32 12,32 7.414,27.414 			"/>
				<polygon points="32,0 20,0 24.586,4.586 20.043,9.125 22.871,11.953 27.414,7.414 32,12 			"/>
			</svg>
		)
	}
}

export class ExitFullScreenIcon extends Component{
	render(){
		let color = this.props.color || "#AAAAAA"
		let style = this.props.style
		return (
			<svg className="icon-exit-full-screen icon" viewBox="0 0 32 32" style={style}>
				<polygon points="22.586,25.414 29.172,32 32,29.172 25.414,22.586 28,20 20,20 20,28    "/>
				<polygon points="6.547,9.371 4,12 11.961,11.957 12,4 9.375,6.543 2.828,0 0,2.828    "/>
				<polygon points="0,29.172 2.828,32 9.414,25.414 12,28 12,20 4,20 6.586,22.586    "/>
				<polygon points="28.031,12 25.438,9.404 32,2.838 29.164,0 22.598,6.566 20,3.971 20,12    "/>
			</svg>
		)
	}
}

export class PlayIcon extends Component{
	render(){
		let color = this.props.color || "##AAAAAA"
		return (
			<svg className="icon icon-play" viewBox="0 0 320.001 320.001">
				<path fill={color} d="M295.84,146.049l-256-144c-4.96-2.784-11.008-2.72-15.904,0.128C19.008,5.057,16,10.305,16,16.001v288
					c0,5.696,3.008,10.944,7.936,13.824c2.496,1.44,5.28,2.176,8.064,2.176c2.688,0,5.408-0.672,7.84-2.048l256-144
					c5.024-2.848,8.16-8.16,8.16-13.952S300.864,148.897,295.84,146.049z"/>
			</svg>
		)
	}
}

export class SliderArrow extends Component{
	render(){
		return (
			<div className={'slider-arrow ' + this.props.className} onClick={this.props.onClick} >
				<Caret direction={this.props.direction} color="#aaaaaa" />
			</div>
		)
	}
}

export const ShowIcon = (props) => {
	return (
		<svg className="icon icon-show" viewBox="0 0 431.3 339">
			<path d="M429.06,135.91c-1-1.39-24-34.24-61.46-67.48-22.15-19.67-44.78-35.38-67.25-46.7C271.71,7.31,243.21,0,215.65,0S159.59,7.31,131,21.73c-22.47,11.32-45.09,27-67.25,46.7C26.26,101.67,3.21,134.52,2.24,135.91a12.5,12.5,0,0,0,0,14.29c1,1.38,24,34.24,61.46,67.48,22.16,19.67,44.78,35.38,67.25,46.69,28.64,14.42,57.14,21.73,84.7,21.73s56.06-7.31,84.7-21.73c22.47-11.31,45.1-27,67.25-46.69,37.44-33.24,60.5-66.1,61.46-67.48A12.5,12.5,0,0,0,429.06,135.91ZM215.65,261.1c-89.56,0-167-91.47-187.55-118,20.59-26.57,98-118,187.55-118s167,91.48,187.55,118.05C382.61,169.63,305.22,261.1,215.65,261.1Z" />
            <path d="M215.65,58.85a84.21,84.21,0,1,0,84.21,84.2A84.2,84.2,0,0,0,215.65,58.85Zm0,143.41a59.21,59.21,0,1,1,59.21-59.21A59.27,59.27,0,0,1,215.65,202.26Z" />
		</svg>
	)
}

export const HideIcon = (props) => {
	return (
		<svg className="icon icon-hide" viewBox="0 0 431.3 339">
			<path d="M215.65,239.71a59.13,59.13,0,0,1-15.26-2L180.9,257.19A84.19,84.19,0,0,0,292.35,145.75l-19.5,19.49a59.18,59.18,0,0,1-57.2,74.47Z" />
            <path d="M383.88,5.27a18,18,0,0,0-25.46,0l-303,303a18,18,0,0,0,25.46,25.46l303-303A18,18,0,0,0,383.88,5.27Z" />
            <path d="M92.18,278l18-18C69.91,231.72,39.81,195.61,28.1,180.5c20.59-26.58,98-118,187.55-118,25.74,0,50.48,7.56,73.15,19l18.55-18.55c-2.33-1.27-4.67-2.5-7-3.68-28.64-14.42-57.14-21.73-84.7-21.73S159.59,44.76,131,59.18c-22.47,11.32-45.09,27-67.25,46.7C26.26,139.12,3.21,172,2.24,173.35a12.52,12.52,0,0,0,0,14.3c1,1.38,24,34.23,61.46,67.47A365,365,0,0,0,92.18,278Z" />
            <path d="M215.65,121.29a58.87,58.87,0,0,1,26.82,6.45l18.31-18.31a84.18,84.18,0,0,0-116.2,116.2l18.31-18.31a59.18,59.18,0,0,1,52.76-86Z" />
            <path d="M429.06,173.35c-1-1.38-24-34.23-61.46-67.47Q358,97.35,348.27,89.82l-17.88,17.89c35.59,27.08,62,58.85,72.81,72.79-20.59,26.58-98,118.05-187.55,118.05-21.67,0-42.63-5.36-62.24-13.86l-18.88,18.87c27.43,13.26,54.71,20,81.12,20,27.56,0,56.06-7.31,84.7-21.73,22.47-11.32,45.1-27,67.25-46.7C405,221.88,428.1,189,429.06,187.65A12.52,12.52,0,0,0,429.06,173.35Z" />
		</svg>
	)
}

export const ShowHideIcon = ({ show }) => (
	show ? (<ShowIcon />) : (<HideIcon />)
)
